<script setup lang="ts">
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem
} from "@/core/components/ui/dropdown-menu";
import {Button} from "@/core/components/ui/button";
import {programApi} from "@/container";
import NotificationProgramFeedbackRejectDialog
    from "@/notification/components/notification-detection/programs/NotificationProgramFeedbackRejectDialog.vue";
import NotificationProgramFeedbackDelayDialog
    from "@/notification/components/notification-detection/programs/NotificationProgramFeedbackDelayDialog.vue";

const props = defineProps<{
    programId: number;
    consumerKey: string;
}>();

const emits = defineEmits(['rejected', 'delayed']);

const hideForDays = async (days: number, reason: string | null = null) => {
    await programApi().createFeedback(props.programId, {
        consumer_key: props.consumerKey,
        type: 'delay',
        data: {
            days,
            reason
        }
    });

    emits("delayed");
};

const hideForever = async (reason: string) => {
    await programApi().createFeedback(props.programId, {
        consumer_key: props.consumerKey,
        type: 'reject',
        data: {
            reason
        }
    });

    emits("rejected");
};
</script>

<template>
  <DropdownMenu :modal="false">
    <DropdownMenuTrigger as-child>
      <Button variant="outline">
        Ne plus notifier le patient au comptoir
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-56">
      <DropdownMenuItem @select="(e) => e.preventDefault()">
        <NotificationProgramFeedbackRejectDialog @submit="hideForever">
          <span>Masquer définitivement</span>
        </NotificationProgramFeedbackRejectDialog>
      </DropdownMenuItem>
      <DropdownMenuItem @click="hideForDays(365 * 2)">
        <span>Masquer pendant 2 ans</span>
      </DropdownMenuItem>
      <NotificationProgramFeedbackDelayDialog @submit="(days, reason) => hideForDays(days, reason)">
        <DropdownMenuItem @select="(e) => e.preventDefault()">
          <span>Masquage personnalisé</span>
        </DropdownMenuItem>
      </NotificationProgramFeedbackDelayDialog>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<style scoped>

</style>
